export default {"src":"/_next/static/media/arrow-left-icon.366bb34e.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};